import { render, staticRenderFns } from "./LoadingPopupWithAsyncFallback.vue?vue&type=template&id=22307e64&scoped=true&"
import script from "./LoadingPopupWithAsyncFallback.vue?vue&type=script&lang=js&"
export * from "./LoadingPopupWithAsyncFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22307e64",
  null
  
)

export default component.exports